import type { FaireProductEntity } from "../../entity_types/product";

export const p_ju4cgcq65q: FaireProductEntity = {
  token: "p_ju4cgcq65q",
  type: "product",
  name: "Football Pearl Bow Clip - Hair Bows - Game Day",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/e13c79ab1407217283552343c7d669c52de804fea3b395a3919ff4a90fdf05f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a7f5e50d7a36072b447464c126f3f53aaf9ce46dacb0a058ca7aa17417e2494f.jpeg",
    "https://cdn.faire.com/fastly/7f14c1b127ea4181af529009d9b0f09531dbebc32b788f3753e6158f84a67416.jpeg",
    "https://cdn.faire.com/fastly/c773740f19012cfbe02b7c92eff42e72c7d4b2b169d77cd5d9eaa0e6936767de.jpeg",
    "https://cdn.faire.com/fastly/644e33cac9f09d5ae6d9e025e1e1882c618769823f22040a3c8336b317215b10.jpeg",
    "https://cdn.faire.com/fastly/9ec59de20256e572cb78c6e191a9e3668ce2d152f11f1dd8193af7680cba7e87.jpeg",
    "https://cdn.faire.com/fastly/f301a3c054818ea858190cdcd26859ee912f5f342dbecf15f07cad865bfc427d.jpeg",
  ],
  priceDollars: 12,
  description:
    "Sweet with a sporty sparkle, this embellished bow clip adds the cutest game day shine to any look.\n\nFeatures:\n * Soft pink bow with football embellishments and pearl accents \n * Ribbon-covered alligator clip to grip the hair \n * One size fits all \n\nPair this hair clip with a matching Sweet Wink tutu and shirt for a complete head-to-toe outfit!",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:21.896Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
